/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes,extraRequire}
 * tslint:disable
 */
var styles = [".custon_rating[_ngcontent-%COMP%]{display:block ruby}body[_ngcontent-%COMP%], html[_ngcontent-%COMP%]{font-family:Montserrat,sans-serif!important}"];
export { styles as styles };

